class VideoSerializer {
  static deSerialize(data) {
    // Youtube urls come in the format:
    // https://youtu.be/YOUTUBE_ID
    // This next code extracts YOUTUBE_ID
    const splitUrl = data.AviUrl.split('/');
    const youtubeId = splitUrl[splitUrl.length - 1];
    return {
      youtubeId,
    };
  }
}

export { VideoSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/VideoSerializer.js